export default "__VITE_ASSET__BSi9O5V8__"